// Components
import ModalContentTokenPurchase from './ModalContentTokenPurchase';
import ModalContentInsufficientPoints from './ModalContentInsufficientPoints';
import ModalContentInsufficientTokens from './ModalContentInsufficientTokens';
import ModalContentInAnotherSession from './ModalContentInAnotherSession';
import ModalContentGeneric from './ModalContentGeneric';

// Constants
import {
    MODAL_GENERIC,
    MODAL_PURCHASE_TOKEN,
    MODAL_INSUFFICIENT_POINTS,
    MODAL_INSUFFICIENT_TOKENS,
    MODAL_IN_ANOTHER_SESSION,
    MODAL_NO_OPEN_TOKEN,
} from '../../../utils/constants/constants';
import ModalContentNoOpenToken from './ModalContentNoOpenToken';

/**
 * @function ModalContentHandler
 * Describes a list of available game sessions
 *
 * @example
 * return (
 *   <ModalContentHandler state='' error='' loadingText='' />
 * )
 */
function ModalContentHandler({ name }: ModalContentHandlerProps): JSX.Element {
    switch (name) {
        case MODAL_PURCHASE_TOKEN:
            return <ModalContentTokenPurchase />;
        case MODAL_INSUFFICIENT_POINTS:
            return <ModalContentInsufficientPoints />;
        case MODAL_INSUFFICIENT_TOKENS:
            return <ModalContentInsufficientTokens />;
        case MODAL_NO_OPEN_TOKEN:
            return <ModalContentNoOpenToken />;
        case MODAL_IN_ANOTHER_SESSION:
            return <ModalContentInAnotherSession />;
        case MODAL_GENERIC:
            return <ModalContentGeneric />;
        default:
            return <></>;
    }
}

/**
 * @interface ModalContentHandlerProps
 * Describes the properties required for the LobbyGrid component
 *
 * @property {string} name Modal name
 */
export interface ModalContentHandlerProps {
    name: string;
}

// Exports
export default ModalContentHandler;
